var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductRetargeting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 100,
    viewBox: "0 0 64 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 177",
    filter: "url(#filter0_d_5330_4787)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 526",
    x: 2.30196,
    y: 0.751178,
    width: 56.2731,
    height: 92.9389,
    rx: 4.02514,
    fill: "white",
    stroke: "currentColor",
    strokeWidth: 0.350012
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 535",
    x: 9.55469,
    y: 87.3672,
    width: 11.7306,
    height: 2.34612,
    rx: 0.700024,
    fill: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 536",
    x: 25.7969,
    y: 87.3672,
    width: 11.7306,
    height: 2.34612,
    rx: 0.700024,
    fill: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 539",
    x: 42.043,
    y: 87.3672,
    width: 11.7306,
    height: 2.34612,
    rx: 0.700024,
    fill: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 537",
    x: 42.043,
    y: 80.4053,
    width: 11.7306,
    height: 2.34612,
    rx: 0.700024,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 538",
    x: 4.91016,
    y: 79.0137,
    width: 11.7306,
    height: 2.34612,
    rx: 0.700024,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 531",
    x: 4.27148,
    y: 23.4258,
    width: 52.4817,
    height: 52.4817,
    rx: 0.700024,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 532",
    x: 38.5031,
    y: 79.1887,
    width: 18.2149,
    height: 4.75536,
    rx: 0.525018,
    stroke: "currentColor",
    strokeWidth: 0.350012
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 499",
    x: 12.8379,
    y: 3.79004,
    width: 22.1351,
    height: 2.14211,
    rx: 0.700024,
    fill: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 527",
    x: 12.8379,
    y: 7.00293,
    width: 9.99652,
    height: 2.14211,
    rx: 0.700024,
    fill: "#DDDFE0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 528",
    x: 4.27148,
    y: 12.3574,
    width: 51.4107,
    height: 2.14211,
    rx: 0.700024,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 529",
    x: 4.27148,
    y: 15.5703,
    width: 48.1975,
    height: 2.14211,
    rx: 0.700024,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 530",
    x: 4.27148,
    y: 18.7842,
    width: 10.7106,
    height: 2.14211,
    rx: 0.700024,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 50",
    cx: 7.66316,
    cy: 6.10945,
    r: 3.21667,
    stroke: "#DDDFE0",
    strokeWidth: 0.350012
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5330_4787",
    x: 0.645849,
    y: 0.576172,
    width: 62.5475,
    height: 99.2135,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1.4811,
    dy: 2.96221
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.4811
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5330_4787"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5330_4787",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductRetargeting);
export default __webpack_public_path__ + "static/media/productRetargeting.081e9c94292a3a4d8dfcb20c94fecd34.svg";
export { ForwardRef as ReactComponent };